import { render, staticRenderFns } from "./HelpFileFormat.vue?vue&type=template&id=a4efb7aa"
import script from "./HelpFileFormat.vue?vue&type=script&lang=js"
export * from "./HelpFileFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports